export default {
  "b2b.cookies-content.text":
    "This website uses exclusively necessary technical cookies."
};
